// extracted by mini-css-extract-plugin
export default {"root":"FlexibleQuotaPromoModal__root--2XLH6","text":"FlexibleQuotaPromoModal__text--2aBBR"};